import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import HomePage from './pages/HomePage';
import WhatWeDo from './pages/WhatWeDo';
import MobileHomePage from './pages/HomePageMobile.js';
import MobileWhatWeDo from './pages/WhatWeDoMobile.js';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { isMobileOnly } from 'react-device-detect'; 
import PayZakat from './pages/PayZakat';
import MobilePayZakat from './pages/PayZakatMobile.js';
import Contact from './pages/Contact';
import MobileContact from './pages/ContactMobile.js';
import FAQMobile from './pages/FAQMobile.js';
import FAQ from './pages/FAQ';
import EidAlAdha from './pages/EidAlAdha';
import MobileEidAlAdha from './pages/EidAlAdhaMobile.js';
import ApplyForHelp from './pages/ApplyForHelp';
import MobileNonMuslims from './pages/NonMuslimsMobile.js';
import NonMuslims from './pages/NonMuslims.js';
import Eid from './pages/Eid.js';
import MobildEid from './pages/EidMobile.js';
import HowItWorks from './pages/HowItWorks';
import MobileHowItWorks from './pages/HowItWorksMobile.js';
import TestimonialsPage from './pages/TestimonialsPage.js';
import Musallah from './pages/musallah.js';
import MusallahMobile from './pages/musallahMobile.js';
import Education from './pages/Education.js';
import EducationMobile from './pages/EducationMobile.js';
import Nueces from './pages/Nueces.js';
import NuecesMobile from './pages/NuecesMobile.js';


const root = ReactDOM.createRoot(document.getElementById('root'));

const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={isMobileOnly ? <MobileHomePage /> : <HomePage />} />
        <Route path="/WhatWeDo" element={isMobileOnly ? <MobileWhatWeDo /> : <WhatWeDo />} />
        <Route path="/PayZakatHere" element={isMobileOnly ? <MobilePayZakat /> : <PayZakat />} />
        <Route path="/FAQ" element={isMobileOnly ? <FAQMobile /> : <FAQ />} />
        <Route path="/Contact" element={isMobileOnly ? <MobileContact /> : <Contact />} />
        <Route path="/HowItWorks" element={isMobileOnly ? <MobileHowItWorks /> : <HowItWorks />} />
        <Route path="/Eid-Al-Adha" element={isMobileOnly ? <MobileEidAlAdha /> : <EidAlAdha />} />
        <Route path="/ApplyForHelp" element={isMobileOnly ? <ApplyForHelp /> : <ApplyForHelp />} />
        <Route path="/NonMuslims" element={isMobileOnly ? <MobileNonMuslims /> : <NonMuslims />} />
        <Route path="/Eid" element={isMobileOnly ? <MobildEid /> : <Eid />} />
        <Route path="/RSVP" element={<ExternalRedirect to="https://bit.ly/4asj2IA" />} />
        <Route path="/Testimonials" element={<TestimonialsPage />} />
        <Route path="/Musallah" element={isMobileOnly ? <MusallahMobile /> : <Musallah />} />
        <Route path="/Education" element={isMobileOnly ? <EducationMobile /> : <Education />} />
        <Route path="/Nueces" element={isMobileOnly ? <NuecesMobile /> : <Nueces />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
